import { AdminListView } from "./AdminListView";
import { channelAdapter } from "./channelAdapter";

export function ChannelAdminPage() {
  return <AdminListView adapter={channelAdapter} />;
}
